// extracted by mini-css-extract-plugin
export default {"wrapper":"Tag-module__wrapper--ada83","icon":"Tag-module__icon--de57a","tag":"Tag-module__tag--c9331"};